import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { useBox } from 'shared/hooks/utils';
import { Box, LinearProgress, Typography } from '@mui/material';
import { TimedRenderer } from 'console/react-elements/timed-renderer';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const useTimer = () => {
    const [active_timer, stopTimer, startTimer] = useBooleanState(false);
    const TimerComponent = useCallback((props) => {
        const { onStart, onEnd, interval, start_value } = props;
        const intervalRef = useRef();
        const counter = useBox(start_value);
        const onStartTimer = useCallback(() => {
            counter.current = start_value;
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            const countTimer = () => {
                if (counter.current === 0) {
                    onEnd?.();
                    // stopTimer();
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                    }
                    return;
                }
                counter.current = counter.current - 1;
            };
            countTimer();
            intervalRef.current = setInterval(countTimer, interval);
        }, [start_value, interval, onEnd]);
        useEffect(() => {
            if (active_timer) {
                onStart?.();
                onStartTimer();
            }
            return () => {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }
            };
        }, [active_timer]);
        return (_jsx(TimedRenderer, { active: active_timer, interval: interval, children: () => (_jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", sx: {
                    opacity: !active_timer ? 0.3 : 1,
                }, children: [_jsx(Typography, { variant: "subtitle1", color: "textSecondary", sx: { minWidth: 35 }, children: `${counter.current} сек` }), _jsx(Box, { width: "100%", children: _jsx(LinearProgress, { variant: "determinate", value: Math.floor((counter.current * 100) / start_value) }) })] })) }));
    }, [active_timer]);
    return [TimerComponent, startTimer, stopTimer];
};
